import * as React from 'react';

import './navbar.css';

export interface ISpbNavbarItem {
  url: string;
  icone: string;
  label: string;
}

export interface ISpbNavbar {
  visible?: boolean;
  items: ISpbNavbarItem[];
  sidNavData: any;
  selectItem?: (value: ISpbNavbarItem) => void;
}

export const SpbNavbar: React.FC<ISpbNavbar> = ({ visible = true, items = [], sidNavData, selectItem }): JSX.Element => {
  const isActiveItems = (url): string => {
    if (typeof window !== 'undefined') return window.location.pathname.includes(url) && url !== '/' ? 'active' : '';
    else return '';
  };

  const handleSelectItem = (value: ISpbNavbarItem): void => {
    if (selectItem) selectItem(value);
  };

  const syncData = (val, attributeKey) => {
    const resulta = sidNavData?.items?.find(v => v.code === val?.code?.toString());
    if (resulta) {
      switch (attributeKey) {
        case 'LABEL':
          return resulta.label;
        case 'ICON':
          return resulta.icon;
        default:
          return '';
      }
    }
  };
  if (!visible) return null;
  else
    return (
      <div className="s-layout">
        <div className="s-sidebar__trigger">
          <img className={'icone-menu'} alt="Logo utilisateur"  src={sidNavData?.smalltopicon?.url}/>
          <img className={'log-img'} alt="Logo utilisateur" src={sidNavData?.topicon?.url} />
        </div>
        <nav className="s-sidebar__nav">
          <ul>
            {items?.map((value, index) => {
              return (
                <React.Fragment key={'s-sidebar' + index}>
                  <li className={isActiveItems(value.url)}>
                    <a className={'s-sidebar__nav-link '} onClick={() => handleSelectItem(value)}>
                      <img src={syncData(value, 'ICON')?.url} alt={value.label} />
                      {syncData(value, 'LABEL')}
                    </a>
                  </li>
                </React.Fragment>
              );
            })}
          </ul>
          <img className={'small-icon-menu-bottom'} alt="Logo utilisateur" src={sidNavData?.bottomicon?.url} />
          <img className={'icon-menu-bottom'} alt="Logo utilisateur"  src={sidNavData?.bottomicon?.url} />
        </nav>
      </div>
    );
};
